module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.ttf?6e435534bd35da5fef04168860a9b8fa";